import React from 'react';
import Icon from 'components/AppIcon';
import Tooltip from 'components/Tooltip';


export default function BulkActionsBar({ selectedCount, onBulkStatusChange, onBulkExport, onClearSelection }) {
  if (selectedCount === 0) return null;
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[150] flex items-center gap-3 bg-slate-800 text-white px-5 py-3 rounded-2xl shadow-2xl"
      style={{ minWidth: '320px' }}>
      <div className="flex items-center gap-2 flex-1">
        <div className="w-6 h-6 rounded-full bg-orange-500 flex items-center justify-center text-xs font-bold flex-shrink-0">
          {selectedCount}
        </div>
        <span className="text-sm" style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}>
          lote{selectedCount !== 1 ? 's' : ''} seleccionado{selectedCount !== 1 ? 's' : ''}
        </span>
      </div>
      <Tooltip description="Cambia el estado de todos los lotes seleccionados a la vez. Se aplicará el mismo estado a todos.">
        <button
          onClick={onBulkStatusChange}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-lg text-xs transition-colors"
          style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}
        >
          <Icon name="RefreshCw" size={13} color="currentColor" />
          Cambiar Estado
        </button>
      </Tooltip>
      <Tooltip description="Exporta los datos de los lotes seleccionados en formato descargable.">
        <button
          onClick={onBulkExport}
          className="flex items-center gap-1.5 px-3 py-1.5 bg-white/10 hover:bg-white/20 rounded-lg text-xs transition-colors"
          style={{ fontFamily: '"IBM Plex Sans", sans-serif' }}
        >
          <Icon name="Download" size={13} color="currentColor" />
          Exportar
        </button>
      </Tooltip>
      <Tooltip description="Deseleccionar todos los lotes marcados.">
        <button
          onClick={onClearSelection}
          className="p-1.5 text-white/60 hover:text-white transition-colors"
          title="Deseleccionar todo"
        >
          <Icon name="X" size={15} color="currentColor" />
        </button>
      </Tooltip>
    </div>
  );
}